import { render, staticRenderFns } from "./BatchGenerateConfig.vue?vue&type=template&id=c6b5a54c&scoped=true"
import script from "./BatchGenerateConfig.vue?vue&type=script&lang=js"
export * from "./BatchGenerateConfig.vue?vue&type=script&lang=js"
import style0 from "./BatchGenerateConfig.vue?vue&type=style&index=0&id=c6b5a54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b5a54c",
  null
  
)

export default component.exports